import { DecimalPipe } from '@angular/common';
import {
  Component,
  EventEmitter,
  Inject,
  Input,
  LOCALE_ID,
  OnInit,
  Output,
} from '@angular/core';
import { Router } from '@angular/router';
import { pathUrl } from 'apps/di-ld/src/app/configs/pathUrl';
import {
  Applications,
  IPendingDocuments,
} from 'apps/di-ld/src/app/core/interfaces';
import {
  JsInterfaceService,
  ApplicationsService,
} from 'apps/di-ld/src/app/core/services';
import { PendingDocumentsService } from 'apps/di-ld/src/app/core/services/pending-documents/pending-documents.service';
import dayjs from 'dayjs';
import {
  CANCEL_FLOW,
  PAYMENT_TYPE_TERM,
} from '../../../../../core/constant/base.enum';
import { AppStateService } from 'apps/di-ld/src/app/app-state.service';
import {
  GA_EVENT_ACTION,
  GA_EVENT_CATEGORY,
  GA_CUSTOM_DIMENSION,
} from 'apps/di-ld/src/app/core/constant/base.enum';
import {
  FirebaseParam,
  EventGATagging,
} from 'apps/di-ld/src/app/core/interfaces/js-interface.interface';
import { HeaderControlService } from 'apps/di-ld/src/app/core/services/header/HeaderControlService';

@Component({
  selector: 'web-di-ld-status-pending-document',
  templateUrl: './status-pending-document.component.html',
  styleUrls: ['./status-pending-document.component.scss'],
})
export class StatusPendingDocumentComponent implements OnInit {
  @Input() selectedData!: any;
  @Input() applicationRef!: string;
  @Input() getCurrentLang?: string;

  @Output() onRefresh = new EventEmitter();

  public paymentTermEnum = PAYMENT_TYPE_TERM;
  pendingDocumentsList?: IPendingDocuments;
  isCollapse?: boolean;
  isListCollapse?: boolean;
  documentCountRequired: number = 0;
  documentCountNotRequired: number = 0;
  extendLoanDialogVisible?: boolean;
  cancelLoanDialogVisible?: boolean;
  viewExampleFailDialogVisible?: boolean;
  isResubmitDocument = false;

  isExtendUploadDocument = false;
  showMoreFlag = false;
  showMoreFlagDocumentNotRequired = false;

  readonly decimalPipe = new DecimalPipe(this._locale);

  constructor(
    @Inject(LOCALE_ID) public _locale: string,
    private pendingDocumentsService: PendingDocumentsService,
    private jsInterfaceService: JsInterfaceService,
    private router: Router,
    private appState: AppStateService,
    private applicationsService: ApplicationsService,
    private headerService: HeaderControlService
  ) {}

  ngOnInit(): void {
    if (this.pendingDocumentsList?.loanAppId == null) {
      this.getDocList();
    }
    if (this.selectedData?.application?.followupExtendDate) {
      this.isExtendUploadDocument = true;
    }
    if (
      this.selectedData?.application?.status_internal === 'RESUBMIT_DOCUMENT'
    ) {
      this.isResubmitDocument = true;
    }
    this.applicationsService.setGaTaggingBasedOnStatus(
      GA_EVENT_CATEGORY.FOLLOWUP_REVIEW_DOC_UPLOAD
    );
    const event = {
      action: GA_EVENT_ACTION.VIEW,
      category: GA_EVENT_CATEGORY.FOLLOWUP_REVIEW_DOC_UPLOAD,
      label: '',
      value: '',
    };
    const dimension = [
      {
        key: GA_CUSTOM_DIMENSION.KEY,
        value: this.selectedData.application.productType,
      },
    ];
    this.gaTagging(event, dimension);
  }

  ngAfterViewInit() {
    this.headerService.triggerStyleChange();
  }

  async getDocList() {
    if (!this.applicationRef) {
      this.applicationRef = this.appState.applicationRef;
    }
    this.pendingDocumentsList = await this.pendingDocumentsService.getDocList(
      this.applicationRef
    );
    this.documentCountRequired =
      this.pendingDocumentsList?.documentType?.filter((doc) => doc.doc_require)
        ?.length || 0;
    this.documentCountNotRequired =
      this.pendingDocumentsList?.documentType?.filter((doc) => !doc.doc_require)
        ?.length || 0;
  }

  toggleDocList() {
    this.isCollapse = !this.isCollapse;
  }

  toggleList() {
    this.isListCollapse = !this.isListCollapse;
    if (this.isListCollapse) {
      const event = {
        action: GA_EVENT_ACTION.CLICK,
        category: GA_EVENT_CATEGORY.FOLLOWUP_REVIEW_DOC_UPLOAD,
        label: `${GA_EVENT_CATEGORY.FOLLOWUP_REVIEW_DOC_UPLOAD}_Seemore`,
        value: '',
      };
      const dimension = [
        {
          key: GA_CUSTOM_DIMENSION.KEY,
          value: this.selectedData.application.productType,
        },
      ];
      this.gaTagging(event, dimension);
    }
  }

  openExtendLoanDialog() {
    const event = {
      action: GA_EVENT_ACTION.CLICK,
      category: GA_EVENT_CATEGORY.FOLLOWUP_REVIEW_DOC_UPLOAD,
      label: `${GA_EVENT_CATEGORY.FOLLOWUP_REVIEW_DOC_UPLOAD}_Extend`,
      value: '',
    };
    const dimension = [
      {
        key: GA_CUSTOM_DIMENSION.KEY,
        value: this.selectedData.application.productType,
      },
    ];
    this.gaTagging(event, dimension);
    this.extendLoanDialogVisible = true;
  }

  cancelExtendLoanDialog() {
    const event = {
      action: GA_EVENT_ACTION.CLICK,
      category: GA_EVENT_CATEGORY.FOLLOWUP_REVIEW_DOC_UPLOAD,
      label: `${GA_EVENT_CATEGORY.FOLLOWUP_REVIEW_DOC_UPLOAD}_ExtendCN`,
      value: '',
    };
    const dimension = [
      {
        key: GA_CUSTOM_DIMENSION.KEY,
        value: this.selectedData.application.productType,
      },
    ];
    this.gaTagging(event, dimension);
    this.extendLoanDialogVisible = false;
  }

  async extendConfirm() {
    const event = {
      action: GA_EVENT_ACTION.CLICK,
      category: GA_EVENT_CATEGORY.FOLLOWUP_REVIEW_DOC_UPLOAD,
      label: `${GA_EVENT_CATEGORY.FOLLOWUP_REVIEW_DOC_UPLOAD}_ExtendCF`,
      value: '',
    };
    const dimension = [
      {
        key: GA_CUSTOM_DIMENSION.KEY,
        value: this.selectedData.application.productType,
      },
    ];
    this.gaTagging(event, dimension);
    const response = await this.pendingDocumentsService.extendFollowup(
      this.applicationRef
    );
    if (response) {
      this.isExtendUploadDocument = true;
      this.onRefresh.emit();
    }
    this.extendLoanDialogVisible = false;
  }

  arriveDate(date?: string) {
    const dateArrive = dayjs(date);
    const dateNow = dayjs();
    const arriveDate = dateArrive.diff(dateNow, 'day');
    return arriveDate === -1 ? '' : arriveDate + 1;
  }

  cancelApplication() {
    const event = {
      action: GA_EVENT_ACTION.CLICK,
      category: GA_EVENT_CATEGORY.FOLLOWUP_REVIEW_DOC_UPLOAD,
      label: `${GA_EVENT_CATEGORY.FOLLOWUP_REVIEW_DOC_UPLOAD}_CancelLoan`,
      value: '',
    };
    const dimension = [
      {
        key: GA_CUSTOM_DIMENSION.KEY,
        value: this.selectedData.application.productType,
      },
    ];
    this.gaTagging(event, dimension);
    this.cancelLoanDialogVisible = true;
  }

  parseToDecimal(value: any) {
    return this.decimalPipe.transform(value, '1.2-2');
  }

  cancelLoanDialog() {
    const event = {
      action: GA_EVENT_ACTION.CLICK,
      category: GA_EVENT_CATEGORY.FOLLOWUP_REVIEW_DOC_UPLOAD,
      label: `${GA_EVENT_CATEGORY.FOLLOWUP_REVIEW_DOC_UPLOAD}_Next`,
      value: '',
    };
    const dimension = [
      {
        key: GA_CUSTOM_DIMENSION.KEY,
        value: this.selectedData.application.productType,
      },
    ];
    this.gaTagging(event, dimension);

    this.cancelLoanDialogVisible = false;
  }

  cancelConfirmLoanDialog() {
    const event = {
      action: GA_EVENT_ACTION.CLICK,
      category: GA_EVENT_CATEGORY.FOLLOWUP_REVIEW_DOC_UPLOAD,
      label: `${GA_EVENT_CATEGORY.FOLLOWUP_REVIEW_DOC_UPLOAD}_Cancel`,
      value: '',
    };
    const dimension = [
      {
        key: GA_CUSTOM_DIMENSION.KEY,
        value: this.selectedData.application.productType,
      },
    ];
    this.gaTagging(event, dimension);

    this.cancelLoanDialogVisible = false;
    this.doCancel();
  }

  openFollowup() {
    const event = {
      action: GA_EVENT_ACTION.CLICK,
      category: GA_EVENT_CATEGORY.FOLLOWUP_REVIEW_DOC_UPLOAD,
      label: `${GA_EVENT_CATEGORY.FOLLOWUP_REVIEW_DOC_UPLOAD}_Upload`,
      value: '',
    };
    const dimension = [
      {
        key: GA_CUSTOM_DIMENSION.KEY,
        value: this.selectedData.application.productType,
      },
    ];
    console.log('🚀 ~ this.selectedData:', this.selectedData);
    console.log('🚀 ~ this.application:', this.selectedData.application);
    console.log(
      '🚀 ~ this.productType:',
      this.selectedData.application.productType
    );
    this.gaTagging(event, dimension);
    //  GA TAGGING WILL NOT SHOW ON LOG WHEN OPEN FOLLOWUP
    this.jsInterfaceService.openFollowup();
  }

  doCancel() {
    this.router.navigate([pathUrl.turndown], {
      state: {
        applicationRef: this.applicationRef,
        from: CANCEL_FLOW.FROM_UPLOAD_DOCUMENT_FLOW,
        selectedData: this.selectedData,
      },
    });
  }

  gaTagging(event: EventGATagging, dimension?: FirebaseParam[]) {
    this.jsInterfaceService.gaTagging(event, dimension);
  }

  showMore() {
    this.showMoreFlag = !this.showMoreFlag;
    if (this.showMoreFlag) {
      const event = {
        action: GA_EVENT_ACTION.CLICK,
        category: GA_EVENT_CATEGORY.FOLLOWUP_REVIEW_DOC_UPLOAD,
        label: `${GA_EVENT_CATEGORY.FOLLOWUP_REVIEW_DOC_UPLOAD}_Seemore`,
        value: '',
      };
      const dimension = [
        {
          key: GA_CUSTOM_DIMENSION.KEY,
          value: this.selectedData.application.productType,
        },
      ];
      this.gaTagging(event, dimension);
    }
  }

  onViewDocumentExampleClick(): void {
    const event = {
      action: GA_EVENT_ACTION.CLICK,
      category: GA_EVENT_CATEGORY.FOLLOWUP_REVIEW_DOC_UPLOAD,
      label: `${GA_EVENT_CATEGORY.FOLLOWUP_REVIEW_DOC_UPLOAD}_Example`,
      value: '',
    };
    const dimension = [
      {
        key: GA_CUSTOM_DIMENSION.KEY,
        value: this.selectedData.application.productType,
      },
    ];
    this.gaTagging(event, dimension);

    let response = this.jsInterfaceService.openFollowupViewOnly();
    if (!response) {
      // fail jsBridge not implemeted
      console.log('openFollowupViewOnly fail');
      setTimeout(() => {
        this.viewExampleFailDialogVisible = true;
      }, 1000); // รอ 1 วินาที ถ้าไม่ redirect to followup แสดง popup error to update version paotang
    }
  }

  closeViewExampleMode() {
    this.viewExampleFailDialogVisible = false;
  }

  showMoreDocumentNotRequired() {
    this.showMoreFlagDocumentNotRequired = !this
      .showMoreFlagDocumentNotRequired;
  }

  checkFollowExpiredDay(application: Applications) {
    if (
      application.followupExpireCountdownDay !== undefined &&
      application.followupExpireCountdownDay >= 0 &&
      application.followupExpireCountdownDay <= 5
    ) {
      return true;
    }
    return false;
  }
}
